const CertificateTypes = {
  EU: 1, 
  USA: 2,
  JAPAN: 3
};

export default CertificateTypes;